import React from "react";
import Header from "./components/Header";
import Game from "./components/Game";

export default function App() {
    const [todaysSong, setTodaysSong] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    async function fetchTodaysSong() {
        try {
            setIsLoading(true);
            const response = await fetch("/todaySong");
            
            if (!response.ok) {
                throw new Error(`Failed to load: ${response.status}`);
            }
            
            const data = await response.json();
            setTodaysSong(data);
            setError(null);
        } catch (error) {
            console.error("Failed to fetch today's song:", error);
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        fetchTodaysSong();
    }, []);

    if (isLoading) {
        return (
            <div>
                <Header />
                <div className="loading-container" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '2rem'
                }}>
                    <div className="loading-spinner" style={{
                        width: '50px',
                        height: '50px',
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #3498db',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginBottom: '1rem'
                    }}></div>
                    <p style={{
                        fontSize: '1.2rem',
                        color: '#666',
                        textAlign: 'center'
                    }}>Loading today's song...</p>
                    <style jsx>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
                <footer></footer>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <Header />
                <div className="error-container" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '2rem'
                }}>
                    <div style={{
                        fontSize: '3rem',
                        marginBottom: '1rem'
                    }}>😞</div>
                    <h2 style={{
                        color: '#e74c3c',
                        marginBottom: '1rem'
                    }}>Oops! Something went wrong</h2>
                    <p style={{
                        color: '#666',
                        textAlign: 'center',
                        marginBottom: '1.5rem'
                    }}>
                        We couldn't load today's song. Please try again.
                    </p>
                    <button 
                        onClick={fetchTodaysSong}
                        style={{
                            padding: '0.8rem 1.5rem',
                            backgroundColor: '#3498db',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '1rem'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
                    >
                        Try Again
                    </button>
                </div>
                <footer></footer>
            </div>
        );
    }

    return (
        <div>
            <Header />
            {todaysSong && <Game todaysSong={todaysSong} />}
            <footer></footer>
        </div>
    );
}